import { useQuery } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';

import { gql } from '../../generated';
import { QueryRootGateGroupArgs, QueryRootVActiveGateArgs } from '../../generated/graphql';

export type UseActiveGateGroupProps = {
  filter?: UseActiveGateGroupFilter;
};

export type UseActiveGateGroupFilter = {
  currency_id?: string;
  merchant_id?: number;
  provider_id?: string;
  gate_type_id?: 'invoice' | 'withdraw';
};

const GET_ACTIVE_GATE_GROUP = gql(/* GraphQL */ `
  query GetActiveGateGroup($whereGateGroup: gate_group_bool_exp, $whereActiveGate: v_active_gate_bool_exp) {
    gate_group(where: $whereGateGroup) {
      id
      name
      active_gate(where: $whereActiveGate) {
        id
        gate_type_id
        currency_id
        alias
      }
    }
  }
`);

export const useActiveGateGroup = (props: UseActiveGateGroupProps) => {
  const getWhere = (filter: UseActiveGateGroupFilter) => {
    const whereGateGroup: QueryRootGateGroupArgs['where'] = {
      active_gate: {
        merchant_id: filter.merchant_id ? { _eq: filter.merchant_id } : undefined,
        provider_id: filter.provider_id ? { _eq: filter.provider_id } : undefined,
        currency_id: filter.currency_id ? { _eq: filter.currency_id } : undefined,
      },
    };

    const whereActiveGate: QueryRootVActiveGateArgs['where'] = {
      gate_type_id: filter.gate_type_id ? { _eq: filter.gate_type_id } : undefined,
    };

    return { whereGateGroup, whereActiveGate };
  };

  return useQuery(GET_ACTIVE_GATE_GROUP, {
    variables: props.filter ? getWhere(props.filter) : undefined,
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });
};
